import { ActionTypeNames, ActionValues, createActionCreators } from '../../../store/actions';
import { IOverlayClass } from './Overlay';

/**
 * Overlays can be stacked, hence pushing and popping. Only the last overlay on
 * the stack gets shown at any time.
 *
 * Otherwise this gets complicated if we ever raise a modal while another overlay
 * is showing. It's a UX smell if we do it in practice, but at least the UI will
 * behave predictably.
 */
export const setOverlayActions = createActionCreators<
	{ T: 'PUSH_OVERLAY', P: { overlay: IOverlayClass } },
	{ T: 'POP_OVERLAY', P: { overlay: IOverlayClass } }
	>('PUSH_OVERLAY', 'POP_OVERLAY');

export const pushOverlay = (overlay: IOverlayClass) => setOverlayActions.PUSH_OVERLAY({ overlay });
export const popOverlay = (overlay: IOverlayClass) => setOverlayActions.POP_OVERLAY({ overlay });

type OverlayActions = ActionValues<typeof setOverlayActions>;
type OverlayActionTypes = ActionTypeNames<OverlayActions>;
export type Actions = OverlayActions[keyof OverlayActions];
export const ActionTypes = Object.keys(setOverlayActions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as OverlayActionTypes);
